import { RCCIcon } from "react-common-components";
import styled from "styled-components";
import { IOverflowSpan } from "./interface";

const OverflowSpan = styled.span<IOverflowSpan>`
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-weight: bold;
    padding-left: 0.2rem;
    margin-left: ${(props) => props.isProject  ? "0.5rem" : "0rem"}
`;

export const RedSpan = styled.span`
    color: var(--red);
    font-weight: bold;
    font-size: 0.82rem;
    text-decoration: line-through;
`;

interface IDivFlex{
    wrap?: boolean;
}

export const DivFlex = styled.div<IDivFlex>`
    display: flex;
    align-items: center;
    ${(props) => props.wrap ? "flex-wrap: wrap;" : ""}
`;

export const DivFlexColumn = styled.div`
    display: flex;
    flex-direction: column;
`;

export const StyledIcon = styled(RCCIcon)`
    border-bottom: 1px solid transparent;
    margin-right: 2px;
    cursor: pointer;
    
    >path{
        stroke: var(--default-color-font);
    }
    transition: 100ms ease;
    
    &:hover{
        cursor: pointer;
        border-bottom: 1px solid var(--default-color-font);
    }
`;

export const DivIcons = styled.div`
    display: flex;
    align-items: center;
    margin: 0 4px;
    padding: 0 0 1px 0;
    border-bottom: 1px solid transparent;

    >svg{
        margin-right: 2px;
    }

    transition: 100ms ease;
    
    &:hover{
        cursor: pointer;
        border-bottom: 1px solid var(--default-color-font);
    }
`;

export const StyledSpan = styled.span`
    color: var(--default-color-font);
    font-weight: bold;
    font-size: 0.75rem;
`;

export default OverflowSpan;
